import M from 'materialize-css'

const MODAL_CLASS = '.modal'

const Modal = () => {
	const init = () => {
		removeOverflowHiddenFromPreviousModals()

		const modalElements: NodeListOf<HTMLElement> = document.querySelectorAll(MODAL_CLASS)
		const instances = M.Modal.init(modalElements)

		for (let i = 0; i < modalElements.length; i++) {
			const instance = instances[i]
			if (!instance) continue

			if (modalElements[i].classList.contains('open')) {
				instance.open()
			}
		}
	}

	const removeOverflowHiddenFromPreviousModals = () => {
		document.body.style.overflow = 'auto'
	}

	return {
		init,
	}
}

export default Modal
